import { useCallback } from 'react';
import { pick } from 'js/utils/ramda.util';
import { jsonToCsv } from 'js/utils/csv.util';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorMessage } from 'js/hooks/server/hooks';

import * as helpers from '../helpers';
import { useParams } from '../../useParams';
import * as actions from '../../../store/actions';
import { useExportSummary } from './useExportSummary';
import { useGetExportTransactions } from './useGetExportTransactions';
import { useDynamicReducerSelector, useDynamicReducerDispatch } from '../../../store';

export const useOnExportClick = () => {
    const isMounted = useIsMounted();
    const params = useParams(true);
    const getErrorMessage = useGetErrorMessage();
    const dispatch = useDynamicReducerDispatch();
    const { summary, playerName } = useExportSummary();
    const getExportTransactions = useGetExportTransactions();
    const { startDate, endDate } = useDynamicReducerSelector(pick(['startDate', 'endDate']));

    return useCallback((downloadCSV) => {
        let exportError = null;

        dispatch(actions.exportTransactions({ exportError, isExportLoading: true }));

        (async () => {
            try {
                const gameTransactionsData = await helpers.getGameExportHistory(params);
                const gameTransactions = getExportTransactions(gameTransactionsData);
                const csv = jsonToCsv([summary, playerName, gameTransactions]);

                csv && downloadCSV({
                    csv,
                    endDate,
                    startDate,
                    fileName: 'game_history'
                });
            } catch (error) {
                exportError = getErrorMessage(error);
            } finally {
                isMounted() && dispatch(actions.exportTransactions({ exportError, isExportLoading: false }));
            }
        })();
    }, [
        params, dispatch, isMounted, summary, startDate,
        endDate, playerName, getErrorMessage, getExportTransactions
    ]);
};
